import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n';
import './index.css';
import './assets/fonts/font.css';
import * as Sentry from '@sentry/react';

import { Chart as ChartJS, registerables } from 'chart.js';
ChartJS.register(...registerables);

const escapeRegExp = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const getOriginFromEnvUrl = (value?: string) => {
  if (!value) return null;

  try {
    return new URL(value).origin;
  } catch {
    return null;
  }
};

const backendOrigin = getOriginFromEnvUrl(process.env.REACT_APP_SERVICES_BACK_HOST);
const authOrigin = getOriginFromEnvUrl(process.env.REACT_APP_SERVICES_HOST);

const sensitivePaths = [
  // 'signup',
  // 'verify-code-email',
  // 'verify-token',
  // 'send-surveys',
  // 'resend-confirmation-code',
  // 'login-with-cellphone',
  'send-email-auth-admin',
];

const buildSafeReplayPattern = (origin: string | null) => {
  if (!origin) return null;

  const escapedOrigin = escapeRegExp(origin);
  const joinedSensitivePaths = sensitivePaths.join('|');

  return new RegExp(
    `^${escapedOrigin}\\/(?!(${joinedSensitivePaths})(?:\\/|\\?|$)).+`,
    'i'
  );
};

const replayNetworkAllowUrls = [
  buildSafeReplayPattern(backendOrigin),
  buildSafeReplayPattern(authOrigin),
].filter(Boolean) as RegExp[];

Sentry.init({
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT ?? 'development',
  dsn: 'https://ad8f3194354aa2ba1a023c671d6d5b18@o1089700.ingest.sentry.io/4506622160863232',

  integrations: [
    new Sentry.BrowserTracing({
      // Evita propagar baggage/sentry-trace para a API enquanto o backend
      // não estiver preparado no CORS para aceitar esses headers.
      tracePropagationTargets: [],
    }),

    new Sentry.Replay({
      maskAllText: false,
      blockAllMedia: false,

      // Captura request/response body apenas para rotas consideradas seguras.
      // Endpoints sensíveis de auth/convite ficam excluídos via regex.
      networkDetailAllowUrls: replayNetworkAllowUrls,

      // Mantém headers extras conservadores. Evite Authorization/Cookie aqui.
      networkRequestHeaders: ['Content-Type', 'Accept'],
      networkResponseHeaders: ['Content-Type', 'Content-Length'],
    }),
  ],

  tracesSampleRate: 1.0,

  replaysSessionSampleRate:
    process.env?.REACT_APP_SENTRY_ENVIRONMENT === 'production' ? 0.025 : 0.0,
  replaysOnErrorSampleRate:
    process.env?.REACT_APP_SENTRY_ENVIRONMENT === 'production' ? 1.0 : 0.0,

  maxValueLength: 2000,
  normalizeDepth: 6,
  normalizeMaxBreadth: 2000,
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(<App />);
